// extracted by mini-css-extract-plugin
module.exports = {"container":"_3M1me","headerCont":"_3pHiN","header":"_17fdS","content":"_2kID4","controls":"_2rOAC","signUpButton":"_1F-R6","mobile":"_3iwT4","desktop":"_18V4L"};